'use strict'

export default {
    delete(id) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'DELETE',
                url: '/api/users/payments/' + id,
                headers: {
                    'Accept': 'application/json'
                }
            }).then(response => {
                resolve(response);
            }).catch(errors => {
                reject(errors.response.data);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/Account/ReusablePayments.js